import { render, staticRenderFns } from "./EmailOfferLandingComponent.vue?vue&type=template&id=ada5d188&scoped=true"
import script from "./EmailOfferLandingComponent.vue?vue&type=script&lang=js"
export * from "./EmailOfferLandingComponent.vue?vue&type=script&lang=js"
import style0 from "./EmailOfferLandingComponent.vue?vue&type=style&index=0&id=ada5d188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada5d188",
  null
  
)

export default component.exports